import {EditFieldType, FieldInfo} from '@/framework/base/components/FieldInfo'
import validator, {RULES_FRENCH_LABEL} from '@/generated/validators/ValidationRules';
import RibIban from '@/generated/controls/rib/RibIban.vue';
import {upperCase} from '@/framework/base/helpers/String';
import Iban from '@/custom/helpers/Iban';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: RibIban,
    computed: {
        editFieldInfo(): FieldInfo {
            const type = EditFieldType.STRING;
            const precision = 2;
            const format = upperCase;
            const mask = this.mask;
            const focus = this.focusValidator;
            const live = null;
            return new FieldInfo(this.ressource, type, precision, mask, format, focus, live, this.theme);
        }
    },
    methods: {
        focusValidator(value: string): validator | null {
            const ibanRule = {function: Iban.isValid.bind(Iban), useMask: false};
            return new validator(ibanRule, RULES_FRENCH_LABEL.text.ibanCheckSumValid.error);
        },
        mask(value: string): string {
            const country = value.substring(0, 2);
            const ibanLength = Iban.getLength(country);
            if (ibanLength != undefined) {
                const unformattedMask = 'AANN' + 'X'.repeat(ibanLength - 4);
                return unformattedMask.match(/.{1,4}/g)?.join(' ') ?? '';
            }
            return value.length > 0 ? 'AANN' : '';
        }
    }
})
